/** Current UI build version (injected by Vite / fcrmUiVersionPlugin). */
export function getAppUiVersion(): string {
  try {
    return String(__APP_UI_VERSION__ || '').trim()
  } catch {
    return ''
  }
}

/** Short display: real semver from package.json (1.x.x) */
export function getAppUiVersionBase(): string {
  try {
    const base = String(__APP_UI_VERSION_BASE__ || '').trim()
    if (/^\d+\.\d+\.\d+$/.test(base)) return base
  } catch {
    /* ignore */
  }
  const full = getAppUiVersion()
  const left = full.split('+')[0] || full
  return /^\d+\.\d+\.\d+$/.test(left) ? left : '1.0.0'
}

/** User-facing label: "v 1.0.0" */
export function getAppUiVersionLabel(): string {
  return `v ${getAppUiVersionBase()}`
}

export function getAppUiCommitCount(): number {
  try {
    const n = Number(__APP_UI_COMMIT_COUNT__)
    return Number.isFinite(n) ? n : 0
  } catch {
    return 0
  }
}
